import { Check, Star, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { ebook } from '../data/content';

export const EbookSection = () => (
  <section data-testid="ebook-section" className="grain relative overflow-hidden bg-pine">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-40 top-[-10%] h-[560px] w-[560px] rounded-full bg-[radial-gradient(circle_at_center,rgba(217,70,239,0.25),rgba(139,92,246,0.12)_45%,transparent_70%)] blur-3xl"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-40 bottom-[-20%] h-[480px] w-[480px] rounded-full bg-emerald-600/40 blur-[130px]"
    />
    <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="grid items-center gap-14 lg:grid-cols-[1.05fr_0.95fr]">
        <div>
          <Reveal>
            <div className="mb-6 flex items-center gap-4">
              <span className="h-px w-16 bg-goldlight" aria-hidden="true" />
              <span className="eyebrow text-goldlight">TheBigHub Digital Marketing Playbook</span>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="text-balance font-display text-4xl font-bold leading-[1.08] text-white sm:text-5xl lg:text-6xl">
              Money Flows to <span className="text-rainbow">Value.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white sm:text-lg">
              {ebook.copy} Our premium digital marketing ebook packs the exact strategies, tools,
              and templates we use into one practical, step-by-step resource.
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <div className="mt-6 flex items-center gap-3" data-testid="ebook-social-proof">
              <span className="flex gap-0.5 text-amber-400" aria-label="Five star rating">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" strokeWidth={0} />
                ))}
              </span>
              <span className="text-sm text-white">Loved by students across Nigeria</span>
            </div>
          </Reveal>
          <Reveal delay={0.28}>
            <div className="mt-8 flex items-baseline gap-3" data-testid="ebook-price">
              <span className="text-rainbow font-display text-5xl font-bold sm:text-6xl">
                {ebook.price}
              </span>
              <span className="text-sm text-white">one-time · instant download on Selar</span>
            </div>
          </Reveal>
          <div className="mt-9 grid gap-3 sm:grid-cols-2" data-testid="ebook-benefits">
            {ebook.bullets.map((b, i) => (
              <Reveal key={b} delay={0.25 + i * 0.05}>
                <div className="flex h-full items-center gap-3 rounded-xl border-2 border-white bg-white px-4 py-3.5">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-forest/10 text-forest">
                    <Check size={14} strokeWidth={3} />
                  </span>
                  <span className="text-sm font-semibold text-forest">{b}</span>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.45}>
            <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link
                to="/digital-marketing-playbook"
                data-testid="ebook-cta-button"
                className="btn border-2 border-white bg-white px-8 py-4 text-base font-bold text-forest hover:-translate-y-0.5 hover:bg-goldlight hover:text-pine hover:shadow-[0_18px_44px_-12px_rgba(255,255,255,0.45)]"
              >
                Get the Playbook — {ebook.price} <ArrowUpRight size={18} />
              </Link>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white">
                Secure checkout · Instant download
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.25} className="relative">
          <div
            className="absolute -inset-5 rounded-[2.25rem] bg-gradient-to-tr from-emerald-500/30 via-sky-500/20 to-fuchsia-500/30 blur-2xl"
            aria-hidden="true"
          />
          <div className="glass relative overflow-hidden rounded-[1.75rem] p-3 shadow-[0_50px_110px_-40px_rgba(0,0,0,0.8)]">
            <img
              src={ebook.image}
              alt={ebook.imageAlt}
              loading="lazy"
              className="w-full rounded-2xl"
              data-testid="ebook-image"
            />
          </div>
          <span className="absolute -top-4 right-8 rounded-full bg-gradient-to-r from-emerald-400 to-sky-400 px-4 py-1.5 font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-pine shadow-lg">
            Official Ebook
          </span>
        </Reveal>
      </div>
    </div>
  </section>
);
